import React from 'react';

const ContactUs = () => {
  return (
    <div className="bg-gray-200 text-gray-800 min-h-screen p-8">
      <h1 className="text-4xl font-bold text-center mb-8">Contact Us</h1>

      {/* Contact Information */}
      <section className="max-w-4xl mx-auto mb-8">
        <h2 className="text-2xl font-semibold mb-4">We're here to help. Reach us through:</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-xl font-medium">Contact Info:</h3>
            <p>Phone: <a href="tel:+923039977677" className="text-[#ff9706e5]">+923039977677</a></p>
            <p>WhatsApp: <a href="https://wa.me/923039977677" className="text-[#ff9706e5]">+923039977677</a></p>
            <p>Email: <a href="mailto:thehazerglobal@gmail.com" className="text-[#ff9706e5]">thehazerglobal@gmail.com</a></p>
          </div>
          <div>
            <h3 className="text-xl font-medium">Address:</h3>
            <p><strong>Physical Address:</strong></p>
            <p>98-J Model Colony, Firdous Market, Gulberg, Lahore, Pakistan.</p>

            <p className="mt-4"><strong>Postal Address:</strong></p>
            <p>The Hazer Global</p>
            <p>98-J Model Colony</p>
            <p>Lahore, Punjab, Pakistan (54020)</p>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="max-w-4xl mx-auto mb-8">
        <h3 className="text-xl font-medium mb-4">Contact Form:</h3>
        <form className="space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Name"
              className="w-full border border-gray-300 p-2 rounded-md"
            />
            <input
              type="email"
              placeholder="Email"
              className="w-full border border-gray-300 p-2 rounded-md"
            />
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <input
              type="tel"
              placeholder="Phone Number"
              className="w-full border border-gray-300 p-2 rounded-md"
            />
            <textarea
              placeholder="Message"
              className="w-full border border-gray-300 p-2 rounded-md h-24"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-[#ff9706e5] text-white px-6 py-2 rounded-md hover:bg-[#ff9706e5]"
          >
            Send Message
          </button>
        </form>
      </section>

      {/* Department-Specific Contacts */}
      <section className="max-w-4xl mx-auto mb-8">
        <h3 className="text-xl font-medium mb-4">Department-Specific Contacts:</h3>
        <ul className="list-disc pl-6">
          <li>Sales: <a href="mailto:sales@companyname.com" className="text-blue-600">sales@companyname.com</a></li>
          <li>Services: <a href="mailto:services@companyname.com" className="text-blue-600">services@companyname.com</a></li>
          <li>Support: <a href="mailto:support@companyname.com" className="text-blue-600">support@companyname.com</a></li>
          <li>Technical: <a href="mailto:technical@companyname.com" className="text-blue-600">technical@companyname.com</a></li>
          <li>Careers: <a href="mailto:careers@companyname.com" className="text-blue-600">careers@companyname.com</a></li>
        </ul>
      </section>

      {/* Working Hours */}
      <section className="max-w-4xl mx-auto mb-8">
        <h3 className="text-xl font-medium mb-4">Working Hours:</h3>
        <p className="text-lg">24/7</p>
      </section>

      {/* Social Media Links */}
       <section className="max-w-4xl mx-auto mb-8">
            <span class="inline-flex">
            <a className="text-[#ff9706e5] cursor-pointer">
              <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="h-5 w-5" viewBox="0 0 24 24">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
              </svg>
            </a>
            <a className="ml-4 text-[#ff9706e5] cursor-pointer">
              <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="h-5 w-5" viewBox="0 0 24 24">
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
              </svg>
            </a>
            <a className="ml-4 text-[#ff9706e5] cursor-pointer">
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="h-5 w-5" viewBox="0 0 24 24">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>
            <a className="ml-4 text-[#ff9706e5] cursor-pointer">
              <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="h-5 w-5" viewBox="0 0 24 24">
                <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
              </svg>
            </a>
            </span>
      </section>

    </div>
  );
};

export default ContactUs;

const ContactForm = () => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start bg-white p-8 md:p-12">
      {/* Contact Us Form */}
      <div className="w-full md:w-1/2 pr-0 md:pr-12 mb-8 md:mb-0">
        <h2 className="text-2xl font-bold mb-6">Contact us</h2>
        <form>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <input
              type="text"
              placeholder="First Name"
              className="w-full md:w-1/2 border rounded-md px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
            />
            <input
              type="text"
              placeholder="Last Name"
              className="w-full md:w-1/2 border rounded-md px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
            />
          </div>
          <input
            type="text"
            placeholder="Phone Number"
            className="w-full border rounded-md px-4 py-2 mb-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
          />
          <textarea
            placeholder="Message"
            rows="5"
            className="w-full border rounded-md px-4 py-2 mb-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
          ></textarea>
          <div className="flex items-center gap-2 mb-4">
            <input type="checkbox" id="privacy" className="w-4 h-4" />
            <label htmlFor="privacy" className="text-gray-600 text-sm">
              You agree to our{" "}
              <span className="text-gray-800 font-medium">Privacy Policy.</span>
            </label>
          </div>
          <button
            type="submit"
            className="bg-black text-white font-semibold px-6 py-3 rounded-md hover:bg-gray-800 transition"
          >
            SEND MESSAGE
          </button>
        </form>
      </div>

      {/* Get in Touch Section */}
      <div className="w-full md:w-1/2">
        <h2 className="text-2xl font-bold mb-6">Get in Touch</h2>
        <p className="text-gray-600 mb-6">
          You need more information? Check what other persons are saying about
          our product. They are very happy with their purchase.
        </p>
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <span className="text-black text-lg font-medium">&#9742;</span>
            <span className="text-gray-800">+1(424) 535 3523</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-black text-lg font-medium">&#9993;</span>
            <span className="text-gray-800">hello@mail.com</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-black text-lg font-medium">&#128221;</span>
            <span className="text-gray-800 font-semibold">Open Support Ticket</span>
          </div>
          <div className='flex items-center gap-2'>
          <span class="inline-flex">
            <a className="text-[#ff9706e5] cursor-pointer">
              <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="h-5 w-5" viewBox="0 0 24 24">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
              </svg>
            </a>
            <a className="ml-4 text-[#ff9706e5] cursor-pointer">
              <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="h-5 w-5" viewBox="0 0 24 24">
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
              </svg>
            </a>
            <a className="ml-4 text-[#ff9706e5] cursor-pointer">
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="h-5 w-5" viewBox="0 0 24 24">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>
            <a className="ml-4 text-[#ff9706e5] cursor-pointer">
              <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="h-5 w-5" viewBox="0 0 24 24">
                <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
              </svg>
            </a>
          </span>
          </div>
        </div>
      </div>

      {/* Social Media Links */}
      <section className="max-w-4xl mx-auto mb-8">
        
      </section>
    </div>
  );
};

// export default ContactForm;